import { Terminal } from '@xterm/xterm';

interface Writer {
  write(data: string): void;
}

const reset = '\x1b[0m';
const hideCursor = '\x1b[?25l';
const showCursor = '\x1b[?25h';

export const escapeCodes = {
  reset,
  clear: '\x1b[g',
  red: '\x1b[1;31m',
};

export const coloredText = {
  red: (text: string) => `${escapeCodes.red}${text}${reset}`,
};

const spinnerFrames = ['⠋', '⠙', '⠹', '⠸', '⠼', '⠴', '⠦', '⠧', '⠇', '⠏'];

export const createSpinner = (terminal: Writer, text: string = '') => {
  let frameIndex = 0;

  terminal.write(hideCursor);

  let spinner: ReturnType<typeof setInterval> | null = setInterval(() => {
    terminal.write('\r');

    terminal.write(`${spinnerFrames[frameIndex]} ${text}`);

    frameIndex = (frameIndex + 1) % spinnerFrames.length;
  }, 120);

  return () => {
    if (spinner) {
      clearInterval(spinner);

      terminal.write('\r');
      terminal.write(showCursor);
    }

    spinner = null;
  };
};

/**
 * Render the text in a terminal so that all the control sequence have been
 * executed and the final content is exactly as it would be if rendered
 * inside a xterm.js.
 *
 * @param data Data that would be sent to the terminal
 */
export function applyControlCharacters(data: string): string {
  let result = '';

  const terminal = new Terminal({
    cols: 100,
  });

  (terminal as any)._core.writeSync(data);

  for (let line = 0; line < terminal.buffer.normal.length; ++line) {
    result += terminal.buffer.normal.getLine(line)?.translateToString(true).trimEnd() + '\n';
  }

  return result.trim();
}
